function convertMinutesToHours(n) {
  var num = n;
  var hours = num / 60;
  var rhours = Math.floor(hours);
  var minutes = (hours - rhours) * 60;
  var rminutes = Math.round(minutes);
  return rhours + ' h ' + rminutes + ' m';
}

export { convertMinutesToHours };
